import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { User } from '@digital-platform/rs-auth/domain';
import { IdentityRepository } from './identity.repository';

@Injectable({
  providedIn: 'root',
})
export class IdentityService {
  private repository: IdentityRepository = inject(IdentityRepository);

  public user$: Observable<User> = this.repository.identity$;

  public isLoggedIn = false;

  public authenticate(identity: User): void {
    this.repository.set(identity);
  }

  public logout(): void {
    this.repository.clear();
  }

  constructor() {
    this.repository.identity$.subscribe((user) => {
      this.isLoggedIn = user && Object.keys(user).length > 0;

      // eslint-disable-next-line no-restricted-syntax
      console.debug(
        `Identity service changed isLoggedIn: ${this.isLoggedIn}, user:`,
        user
      );
    });
  }
}
